import React, {useEffect, useState} from "react";
import axios from "axios";
import {useNavigate, useParams} from "react-router-dom";

const VendorPage = ({}) => {
    const id = useParams().id;
    const [vendorData, setVendorData] = useState(null);
    const [channelManagers, setChannelManagers] = useState([]);
    const navigate = useNavigate();

    const goback = async() => {
        navigate('/vendorList')
    }

    const getVendorData = async() => {
        const userToken = localStorage.getItem("user-token");

        const headers = {
            "authorization": userToken,
        };

        let bUrl = `/channel/vendor/${id}`;

        try {
            const response = await axios.get(bUrl, {headers: headers});
            setVendorData(response.data.vendorData);
            setChannelManagers(response.data.chanelManagers);
        } catch (error) {
            console.error("Error fetching vendor data:", error);
        }
    };

    const getChannelManagers = async () => {
        const userToken = localStorage.getItem("user-token");

        const headers = {
            "authorization": userToken,
        };

        let bUrl = `/channel/channel-manager`;

        try {
            const response = await axios.get(bUrl, {headers: headers});
            setChannelManagers(response.data.data);
        } catch (error) {
            console.error("Error fetching channel managers:", error);
        }
    }

    useEffect(() => {
        getVendorData();
        getChannelManagers();
    }, [id]);

    if (!vendorData) {
        return <div>Loading....</div>;
    }

    // Find the channel manager associated with this vendor
    const vendorChannelManager = channelManagers.find(manager => manager._id === vendorData.channelManagerID);

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Vendor Details</h1>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <p><strong>Vendor Code:</strong> {vendorData.vendorCode}</p>
                    <p><strong>Name:</strong> {vendorData.userName}</p>
                    <p><strong>Phone Number:</strong> {vendorData.phoneNum}</p>
                    <p><strong>Email:</strong> {vendorData.emailId}</p>
                    <p><strong>City:</strong> {vendorData.city}</p>
                    <p><strong>State:</strong> {vendorData.state}</p>
                    <p><strong>Company Name:</strong> {vendorData.companyName}</p>

                    <button onClick={goback} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4">
                        Back to Vendor List
                    </button>
                </div>

                <div>
                    {/*<h2 className="text-xl font-semibold mb-2">Channel Manager</h2>*/}
                    {/*{vendorChannelManager ? (*/}
                    {/*    <div>*/}
                    {/*        <p><strong>Name:</strong> {vendorChannelManager.firstName} {vendorChannelManager.lastName}</p>*/}
                    {/*        <p><strong>Email:</strong> {vendorChannelManager.emailId}</p>*/}
                    {/*        <p><strong>Phone:</strong> {vendorChannelManager.phoneNum}</p>*/}

                    {/*    </div>*/}
                    {/*) : (*/}
                    {/*    <p>No Channel Manager assigned.</p>*/}
                    {/*)}*/}

                    <h2 className="text-xl font-semibold mt-4 mb-2">All Channel Managers:</h2>
                    <ul>
                        {channelManagers.map(manager => (
                            <li key={manager._id} className="mb-2 p-2 border rounded">
                                <strong>Name:</strong> {manager.username} <br/>
                                <strong>Code:</strong> {manager.code} <br/>
                                <strong>Email:</strong> {manager.email}<br/>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default VendorPage;
